import React from "react"
import autobind from "class-autobind"
import { Table, TableHeaderColumn, TableRow, TableHeader, TableRowColumn, TableBody, IconButton } from "material-ui"
import strings from "../../../../localization/strings"
import { IScheduleTemplate, ISchedulePatternTemplate } from "../../../../models"
import * as scheduleHelper from "../../../../helpers/scheduleHelper"
import ScheduleTemplateTimeinfoDetailDayView from "./ScheduleTemplateTimeinfoDetailDayView"
import Copy from "../../../../../assets/icons/copy"
import * as permissionHelper from "../../../../helpers/permissionHelper"
import AuthenticationStore from "../../../../stores/AuthenticationStore"
interface IProps {
    scheduleTemplate: IScheduleTemplate
    handleChangeSelectedDay(day: number): void
    handleDeletePatternTemplates(patternTemplates: ISchedulePatternTemplate[]): void
    handleUpdatePatternTemplateQty(newPatternTemplate: ISchedulePatternTemplate, quantity: number): void
    handleOpenCloneDialog(candidateClonePatternTemplates: ISchedulePatternTemplate[], clonedDay: number): void
    handleUpdateUniquePatternTemplate(uniquePatternTemplate: ISchedulePatternTemplate): void
}
interface IState {
    extendedDay: number
}

export default class ScheduleTemplateTimeinfoDetailListView extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            extendedDay: -1
        }
        autobind(this)
    }

    render() {
        return (
            <Table multiSelectable={false} selectable={false}>
                <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                    <TableRow>
                        <TableHeaderColumn style={{ paddingLeft: 5, paddingRight: 5, width: 40 }}>{strings.Day}</TableHeaderColumn>
                        <TableHeaderColumn style={{ textAlign: "center", width: 75 }}>{strings.Total_Shifts}</TableHeaderColumn>
                        <TableHeaderColumn style={{ paddingLeft: 0, paddingRight: 0 }} />
                        <TableHeaderColumn style={{ width: 30, paddingLeft: 10, paddingRight: 10 }} />
                    </TableRow>
                </TableHeader>
                <TableBody showRowHover={false} deselectOnClickaway={false} displayRowCheckbox={false}>
                    {new Array(scheduleHelper.getDayLengthFromStartAndEndTime(this.props.scheduleTemplate.StartDate, this.props.scheduleTemplate.EndDate)).fill("").map((row, index) => {
                        const patternTemplatesForDay = scheduleHelper.getPatternTemplatesForDay(this.props.scheduleTemplate.StartDate, index, this.props.scheduleTemplate.PatternTemplates)
                        return (
                            <TableRow key={index}>
                                <TableRowColumn style={{ paddingLeft: 0, paddingRight: 0 }}>
                                    <Table style={{ backgroundColor: "none" }} selectable={false}>
                                        <TableBody displayRowCheckbox={false}>
                                            <TableRow style={{ cursor: "pointer", height: 48, borderBottom: "none" }}>
                                                <TableRowColumn style={{ paddingLeft: 5, paddingRight: 5, width: 40 }}>
                                                    {strings.formatString(strings.Day_X, index + 1)}
                                                </TableRowColumn>
                                                <TableRowColumn style={{ textAlign: "center", width: 75 }}>
                                                    {patternTemplatesForDay.length}
                                                </TableRowColumn>
                                                <TableRowColumn style={{ textAlign: "right", paddingLeft: 0, paddingRight: 0 }}>
                                                    {this.state.extendedDay === index && patternTemplatesForDay.length > 0 &&
                                                        permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.EditAccountSchedule) &&
                                                        <IconButton
                                                            data-intercom-target={`ScheduleTemplates-TimeInfoDetails-ListView-Btn-OpenClondeDialogForRow${index + 1}`}
                                                            onClick={() => this.props.handleOpenCloneDialog(patternTemplatesForDay, index)}
                                                            style={{ padding: 0, width: 20, height: 20 }}
                                                        >
                                                            <Copy width={17.5} height={15} color="rgb(97, 97, 97)" />
                                                        </IconButton>
                                                    }
                                                </TableRowColumn>
                                                <TableRowColumn style={{ width: 30, paddingLeft: 10, paddingRight: 10 }}>
                                                    <i
                                                        data-intercom-target={`ScheduleTemplates-TimeInfoDetails-ListView-ExpandOrCollapseRow${index + 1}Details`}
                                                        onClick={(e) => {
                                                            e.stopPropagation()
                                                            const extendedDay = this.state.extendedDay === index ? -1 : index
                                                            this.setState({ extendedDay })
                                                            this.props.handleChangeSelectedDay(extendedDay)
                                                        }}
                                                        className={this.state.extendedDay === index ? "fa fa-chevron-up" : "fa fa-chevron-down"}
                                                        style={{ fontSize: 18 }}
                                                    />
                                                </TableRowColumn>
                                            </TableRow>
                                            {this.state.extendedDay === index &&
                                                <TableRow >
                                                    <TableRowColumn
                                                        colSpan={4}
                                                        style={{ paddingRight: 5, paddingLeft: 90 }}
                                                    >
                                                        <div onClick={e => e.stopPropagation()} style={{ marginTop: -30 }}>
                                                            <ScheduleTemplateTimeinfoDetailDayView
                                                                patternTemplates={patternTemplatesForDay}
                                                                handleDeletePatternTemplates={this.props.handleDeletePatternTemplates}
                                                                handleUpdatePatternTemplateQty={this.props.handleUpdatePatternTemplateQty}
                                                                handleUpdateUniquePatternTemplate={this.props.handleUpdateUniquePatternTemplate}
                                                            />
                                                        </div>
                                                    </TableRowColumn>
                                                </TableRow>
                                            }
                                        </TableBody>
                                    </Table>
                                </TableRowColumn>
                            </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
        )
    }
}